const MIN_SC_COUNT = 5;

export function useSocialCues() {
  const { t } = useI18n();

  const getSocialCuesCount = (totalGuests) => {
    const parsedTotalGuests = Number(totalGuests);
    if (Number.isNaN(parsedTotalGuests) || parsedTotalGuests <= 0) {
      return 0;
    }

    return parsedTotalGuests;
  };

  const getSocialCuesLabel = (totalGuests) => {
    const parsedTotalGuests = Number(totalGuests);
    if (Number.isNaN(parsedTotalGuests) || parsedTotalGuests <= 0) {
      return '';
    }

    let socialCuesCount = 0;
    if (parsedTotalGuests >= 10) {
      socialCuesCount = Math.floor(parsedTotalGuests / 10) * 10;
    } else if (parsedTotalGuests < 10 && parsedTotalGuests >= 5) {
      socialCuesCount = 5;
    }

    if (socialCuesCount < MIN_SC_COUNT) {
      return t('t_STAYING');
    }

    return `${socialCuesCount}+ ${t('t_STAYING')}`;
  };

  return {
    socialCues: {
      getSocialCuesCount,
      getSocialCuesLabel,
    },
  };
}
